export default function PageSuspenseFallback() {
  return (
    <div
      className="page-suspense-fallback"
      aria-busy="true"
      aria-label="Loading page"
    >
      <div className="spinner big" />
    </div>
  );
}
